import { useState, useRef, useContext } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  Typography,
} from '@mui/material';

import { DataLoading, Button as CustomButton } from '../common';
import colors from '../../assets/colors';
import { directPayment } from '../../utils/api';
import FarmContext from '../../store/farm-context';

const ConfirmationUploadDialog = ({ open, handleAction, directPaymentID }) => {
  const hiddenFileInput = useRef(null);
  const [errorText, setErrorText] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [successful, setSuccessful] = useState(true);
  const farmCTX = useContext(FarmContext);

  const handleClose = () => {
    setSuccessful(true);
    setIsUploading(false);
    handleAction(false);
  };
  const handleInputClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onChangeHandler = async (event) => {
    await uploadFile(event.target.files[0]);
  };

  const uploadFile = (fileup) => {
    setIsUploading(true);
    const data = new FormData();
    data.append('file', fileup);
    data.append('id', directPaymentID);
    directPayment
      .confirm(directPaymentID, farmCTX.farmID, data)
      .then((result) => {
        if (result.status === 200) {
          setIsUploading(false);
          handleClose();
        }
      })
      .catch((err) => {
        try {
          if (err.response.status === 400) {
            setIsUploading(false);
            setSuccessful(false);
            setErrorText('Numery dokumentów nie są zgodne!');
          } else if (err.response.status === 500) {
            setIsUploading(false);
            setSuccessful(false);
            setErrorText('Błędny format pliku!');
          }
        } catch (err) {}
      });
  };

  return (
    <Dialog
      PaperProps={{
        style: {
          backgroundColor: colors.white,
          color: colors.oldAgroweGreen,
          width: '65%',
        },
      }}
      open={open}
    >
      <DialogTitle align="center" sx={{ p: 2, mt: 1 }}>
        Dodaj potwierdzenie wniosku o dopłaty bezpośrednie
      </DialogTitle>
      <DialogContent>
        {isUploading ? (
          <DataLoading />
        ) : successful ? (
          <Box component="div" sx={{ marginTop: 1 }}>
            <CustomButton
              type="submit"
              variant="contained"
              fullWidth
              onClick={handleInputClick}
              aria-label="upload button"
            >
              Umieść potwierdzenie wniosku o dopłaty
            </CustomButton>
            <input
              data-testid="fileInput"
              ref={hiddenFileInput}
              style={{ display: 'none' }}
              id="file"
              type="file"
              name="file"
              onChange={onChangeHandler}
            />
          </Box>
        ) : (
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            sx={{ textAlign: 'center', marginBottom: '8%' }}
          >
            <Typography variant={'h5'} sx={{ color: colors.redError }}>
              {errorText}
            </Typography>
          </Grid>
        )}
        <CustomButton
          variant="contained"
          fullWidth
          onClick={handleClose}
          aria-label="close button"
        >
          Zamknij okno
        </CustomButton>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationUploadDialog;
